import API from '@/services/endpoint'
import {DELETE_AN_EVENT, GET_MY_EVENTS} from "../../mutation-types";

/**
 * GET request for event reservation
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event information
 */
export function fetchMyEvents({commit, state}, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { url } = state
      let responseObj = await API.get(url, payload);
      let { data: { message: { reservations } } } = responseObj;
      commit(GET_MY_EVENTS, reservations)
      resolve(reservations)
    } catch (e) {
      reject(e.response.data)
    }
  })
}

/**
 * DELETE request to delete a reservation
 * @param dispatch
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event to be deleted
 */
export function deleteSelectedEvent({dispatch, commit, state}, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      let { url, myEvents } = state
      let responseObj = await API.delete(`${url}/${payload}`);
      let { data } = responseObj;
      commit(DELETE_AN_EVENT, payload)
      const updatedEvents = myEvents.filter(el => el.id !== payload);
      commit(GET_MY_EVENTS, updatedEvents)
      resolve(data)
    } catch (e) {
      if ( e.response ) {
        reject(e.response.data)
      }
    }
  })
}
